import filter from "./filter.js";
import negate from "./negate.js";
import cb from "./_cb.js";
export default function reject(obj, predicate, context) {
  return filter(obj, negate(cb(predicate)), context);
}
